import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import SignIn from "./../../pages/SignIn/SignIn";
import TalaeraDefaultBackground from "./../TalaeraDefaultBackground/TalaeraDefaultBackground";
import PasswordResetDone from "../../pages/PasswordResetDone/PasswordResetDone";
import TalaeraRoutes from "./TalaeraRoutes";
import SelfSignUp from "../../pages/SelfSignUp/SelfSignUp";
import SelfForgotPassword from "../../pages/SignIn/ForgotPassword";
import PasswordReset from "../../pages/SignIn/PasswordReset";
import { isUserAuthenticated, verifyPassword } from "../../services/authUtil";
import SignUpByInvitation from "../../pages/SignUpByInvitation";
import SignInSSO from "../../pages/SignInSSO";
import { ErrorBoundary } from "../ErrorBoundary";
import { NotFoundPage } from "../../pages/Error/NotFoundPage";
import { WrongLinkPage } from "../../pages/Error/WrongLink";
import React from "react";
import OAuthLoadingPage from "../../pages/OAuthLoading";
import VerifyPendingUser from "pages/VerifyPendingUser";

const GuestCheck = props =>
  props.enable && isUserAuthenticated() ? <WrongLinkPage /> : props.children;

export default function UnauthRoutes(props) {
  const location = useLocation();

  return (
    <ErrorBoundary pathname={location?.pathname}>
      <Routes key={location.pathname} location={location}>
        <Route
          path={TalaeraRoutes.SELF_SIGNUP_VERIFY_INDIVIDUAL.path}
          element={<VerifyPendingUser />}
        />

        <Route path={TalaeraRoutes.VERIFY.path} element={<VerifyPendingUser />} />

        <Route
          path={TalaeraRoutes.RESET_DONE.path}
          element={
            <GuestCheck enable={props.showWrongLinkIfAuthenticated}>
              <TalaeraDefaultBackground>
                <PasswordResetDone withLogo={true} />
              </TalaeraDefaultBackground>
            </GuestCheck>
          }
        />
        <Route
          path={TalaeraRoutes.CHANGE_PASSWORD.path}
          element={
            <GuestCheck enable={props.showWrongLinkIfAuthenticated}>
              <PasswordReset
                smallWindow={props.smallWindow}
                location={location}
                unauth={true}
              />
            </GuestCheck>
          }
        />
        <Route
          path={TalaeraRoutes.SIGN_IN_SSO.path}
          element={<SignInSSO withLogo={true} />}
        />
        <Route
          path={TalaeraRoutes.SIGN_IN_OAUTH.path}
          element={
            <GuestCheck enable={props.showWrongLinkIfAuthenticated}>
              <OAuthLoadingPage />
            </GuestCheck>
          }
        />
        <Route
          path={TalaeraRoutes.SIGN_IN.path}
          element={
            <GuestCheck enable={props.showWrongLinkIfAuthenticated}>
              <SignIn withLogo={true} />
            </GuestCheck>
          }
        />
        <Route
          path={TalaeraRoutes.SIGN_UP_SETUP_WITH_CODE.path}
          element={
            <GuestCheck enable={props.showWrongLinkIfAuthenticated}>
              <SelfSignUp withLogo={true} showToast={props.showToast} />
            </GuestCheck>
          }
        />
        <Route
          path={TalaeraRoutes.SIGN_UP_WITH_CODE.path}
          element={
            <GuestCheck enable={props.showWrongLinkIfAuthenticated}>
              <SelfSignUp withLogo={true} showToast={props.showToast} />
            </GuestCheck>
          }
        />
        <Route
          path={TalaeraRoutes.SELF_SIGN_UP.path}
          element={
            <GuestCheck enable={props.showWrongLinkIfAuthenticated}>
              <SelfSignUp withLogo={true} showToast={props.showToast} />
            </GuestCheck>
          }
        />

        <Route
          path={TalaeraRoutes.INVITE_VERIFY.path}
          element={
            <GuestCheck enable={props.showWrongLinkIfAuthenticated}>
              <SignUpByInvitation withLogo location={location} />
            </GuestCheck>
          }
        />

        <Route
          path={TalaeraRoutes.FORGOT.path}
          element={
            <GuestCheck enable={props.showWrongLinkIfAuthenticated}>
              <SelfForgotPassword showToast={props.showToast} />
            </GuestCheck>
          }
        />

        <Route
          path={TalaeraRoutes.PASSWORD_VERIFY.path}
          element={
            <GuestCheck enable={props.showWrongLinkIfAuthenticated}>
              <PasswordReset
                verifyService={verifyPassword}
                smallWindow={props.smallWindow}
                location={location}
                unauth={true}
              />
            </GuestCheck>
          }
        />

        <Route path={TalaeraRoutes.NOT_FOUND.path} element={<NotFoundPage />} />

        <Route
          path={"*"}
          element={
            <Navigate
              to={
                props.showWrongLinkIfAuthenticated
                  ? TalaeraRoutes.NOT_FOUND.path
                  : TalaeraRoutes.SIGN_IN.path
              }
              replace
            />
          }
        />
      </Routes>
    </ErrorBoundary>
  );
}
